export const defaultStyle = {
    focus: 'focus:border-primary-text focus:border',
    hover: 'hover:bg-primary-hover',
    active: 'active:bg-primary-active',
    font: 'text-center font-sans',
};
//# sourceMappingURL=defaultStyle.js.map